import React from 'react';

function StatCard({ label, value, sub, accentColor }) {
  return (
    <div className="stat-card" style={{ borderTop: `2px solid ${accentColor || 'var(--accent)'}` }}>
      <div className="stat-card__value">{value ?? 0}</div>
      <div className="stat-card__label">{label}</div>
      {sub && <div className="stat-card__sub">{sub}</div>}
    </div>
  );
}

export default StatCard;
